import { useUserData } from 'commons/contexts';
import { MenuItems } from 'commons/utils/menu/menu';
import { useLocation, useNavigate } from 'react-router-dom';
import { Menu as MenuRoot } from '../DSMenu/Menu';
import { UserPermission, UserProfile } from 'commons/types/user';
import { GESTAO_FIGURACAO, TIME_COMFIGURA } from 'commons/constants/profiles';

const Menu = () => {
  const { hasResource: hasUserPermission, hasProfiles: hasUserProfile } = useUserData();
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string) => location.pathname + location.search === path;

  const onItemClick = (path?: string) => {
    if (path) navigate(path);
  };

  const hasResource: (permissions: string[]) => boolean = permissions => {
    return hasUserPermission(permissions as UserPermission[]);
  };

  const hasProfiles: (profiles: string[]) => boolean = profiles => {
    return hasUserProfile(profiles as UserProfile[]);
  };

  const filteredMenuItems = MenuItems.map((item, index) => {
    const hasAnyPermission = item.permissions?.length ? hasResource(item.permissions) : true;
    const hasAnyProfiles = item.profiles?.length ? hasProfiles(item.profiles) : true;

    if (!hasAnyProfiles || !hasAnyPermission) return null;
    if (hasProfiles([TIME_COMFIGURA, GESTAO_FIGURACAO]) && index !== 0) return null;
    return item;
  }).filter(item => item);

  const hasOnePage =
    !hasProfiles([TIME_COMFIGURA, GESTAO_FIGURACAO]) &&
    filteredMenuItems.length === 1 &&
    filteredMenuItems[0]?.subItems?.length === 0;

  return (
    <MenuRoot
      items={hasOnePage ? [] : filteredMenuItems}
      isActive={isActive}
      onItemClick={onItemClick}
      onSubMenuItemClick={onItemClick}
    />
  );
};

export default Menu;
